module.exports = __webpack_public_path__ + "static/media/storepreviewStoreSix.db942139.svg";